import {TextField } from 'react-admin';

const TextFieldGrid = (props) => {
    return <TextField  {...props} style={{ color: 'black', fontFamily: 'Gothic', width:'100px', height:'100px' }} />;
  };

  export default TextFieldGrid;